import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { blogs } from 'src/assets/blogs';
import { _ } from 'underscore';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-blog-article',
  templateUrl: './blog-article.component.html',
  styleUrls: ['./blog-article.component.css'],
})
export class BlogArticleComponent implements OnInit {
  // @Input() countVisible: number;
  currentArticle;
  articleNum;
  articleNumber = '';
  fArticle = true;
  userObj = {
    emailId: '',
  };
  sections;
  blogsList = [];
  continueBlogs;
  shareUrl;
  msg;
  time = 3000;
  timer;
  twitterShare;
  fbShare;

  constructor(
    private router: Router,
    private residentialService: ResidentialService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
    this.blogsList = blogs;
    //// console.log.log(this.route.url['value'][2]);
    this.articleNumber =
      this.route.url['value'][2] != undefined
        ? this.route.url['value'][2].path
        : this.route.url['value'][1].path;

    const anum = parseInt(this.articleNumber);
    this.continueBlogs = _.filter(this.blogsList, function (item) {
      return item.article_number !== anum;
    });
    this.shareUrl = window.location.host;
    //this.fbShare = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//'+this.shareUrl+'/%23/blog/'+this.articleNumber;

    this.fbShare =
      'https://www.facebook.com/sharer/sharer.php?u=https%3A//' +
      this.shareUrl +
      '/blog/' +
      this.articleNumber;
    //this.twitterShare = 'https://twitter.com/home?status=https%3A//'+this.shareUrl+'/blog/'+this.articleNumber;
    this.twitterShare =
      'https://twitter.com/intent/tweet?source=tweetbutton&url=https%3A//' +
      this.shareUrl +
      '/' +
      'blog/' +
      this.articleNumber;
    // // console.log.log(this.shareUrl);
    // this.shareUrl = 'https://stage.honestgorilla.com/blog/article/article_number=1'
    // this.residentialService.setShowArticle.subscribe((data) => {
    //   // console.log.log('data::::::::' + data.articleNum, blogs);
    //   this.articleNumber = data.articleNum;
    // });
  }

  public getSantizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  ngOnInit() {
    // // console.log.log(this.countVisible);
    //// console.log.log(this.blogsList);

    const userObj = sessionStorage.getItem('userObj');

    if (!_.isEmpty(userObj) && JSON.parse(userObj).emailId) {
      var flag = 'true';
      sessionStorage.setItem('logoutFlag', flag);
    }

    var name = window.location.href.split('/').pop();
    if (name.includes('burning-money')) {
      name = 'If you’re not saving energy, you’re burning money';
    } else if (name.includes('why-you')) {
      name =
        'Why you shouldn’t trust anyone’s recommendation when it comes to this one thing.';
    } else if (name.includes('your-home') || name.includes('Your')) {
      name = 'Your home as a fortress for well-being';
    } else if (name.includes('3-things')) {
      name = '3 things you need to know before renting an apartment';
    }
    this.currentArticle = _.findWhere(this.blogsList, { article_header: name });
  }

  articleNavigate(count) {
    if (count == 1) {
      count = 'if-youre-not-saving-energy-youre-burning-money';
    } else if (count == 2) {
      count =
        'why-you-shouldn’t-trust-anyones-recommendation-when-it-comes-to-this-one-thing';
    } else if (count == 3) {
      count = 'your-home-as-a-fortress-for-wellbeing';
    } else if (count == 4) {
      count = '3-things-you-need-to-know-before-renting-an-apartment';
    }
    this.articleNumber = count;
    this.router.navigate(['/blog/', count]);
    this.residentialService.setArticleFlag({ articleNum: this.articleNumber });
  }

  // Form validation
  createAccount(event, myForm, formValid) {
    if (formValid) {
      myForm.resetForm();
      clearTimeout(this.timer);
      this.msg = 'Subscribed.';
      this.timer = setInterval(() => {
        this.msg = '';
      }, this.time);
    }
    // // console.log.log('*************', +event);
  }

  showSerched(tag) {
    this.residentialService.messageService({ tag: tag });
    this.router.navigateByUrl('/blog');
  }
}
